<template>
  <v-row no-gutters justify="center" align="start">
    <div class="ml-6 mr-6 n-container">
      <new-ticket />
    </div>
  </v-row>
</template>

<script>
import NewTicket from '@/components/NewTicket/index.vue';

export default {
  components: {
    NewTicket,
  },
};
</script>
